import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { useStoreSyncedWithLocalStorage } from "common/store/store";
import {
  addDaysToDate,
  startOfMonthAsDate
} from "common/utils/time";
import React from "react";
import { MobilicHeader } from "../../../common/Header";
import { useLoadControls } from "../../utils/loadControls";
import { ControllerControlDrawer } from "../details/ControllerControlDrawer";
import { ControlsList } from "../list/ControlsList";
import { ControllerHistoryFilters } from "./ControllerHistoryFilters";
import { usePageTitle } from "../../../common/UsePageTitle";
import { Main } from "../../../common/semantics/Main";

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(7),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    margin: 0,
    textAlign: "center"
  },
  whiteSection: {
    backgroundColor: theme.palette.background.paper
  }
}));

export function ControllerHistory() {
  usePageTitle("Historique Contrôle - Mobilic");
  const classes = useStyles();
  const store = useStoreSyncedWithLocalStorage();
  const controllerUserInfo = store.controllerInfo();

  const [controlOnFocus, setControlOnFocus] = React.useState(null);

  const [controlFilters, setControlFilters] = React.useState({
    fromDate: startOfMonthAsDate(addDaysToDate(new Date(), -91)
    ),
    toDate: new Date(),
    controlsType: ""
  });
  const [period, setPeriod] = React.useState("day");
  const [controls, loadControls, loadingControls] = useLoadControls();

  const _loadControls = () => {
    loadControls({
      controllerId: controllerUserInfo.id,
      ...controlFilters
    });
  };

  React.useEffect(() => {
    _loadControls();
  }, [controlFilters]);
  return (
    <>
      <MobilicHeader />
      <Main
        className={`${classes.container} ${classes.whiteSection}`}
        maxWidth="xl"
      >
        <ControllerControlDrawer
          controlId={controlOnFocus?.id}
          controlType={controlOnFocus?.type}
          onClose={() => {
            _loadControls();
            setControlOnFocus(null);
          }}
        />
        <Typography
          sx={{ typography: { xs: "h3", sm: "h1" } }}
          component="h1"
          mb={{ xs: 2, sm: 3 }}
        >
          Historique des contrôles
        </Typography>
        <Box
          sx={{
            marginBottom: theme => ({
              xs: theme.spacing(2),
              md: theme.spacing(12)
            })
          }}
        >
          <ControllerHistoryFilters
            controlFilters={controlFilters}
            setControlFilters={setControlFilters}
            period={period}
            setPeriod={setPeriod}
          />
        </Box>
        {controls && controls.length > 0 && (
          <ControlsList
            controls={controls}
            period={period}
            loading={loadingControls}
            clickOnRow={(id, type) => setControlOnFocus({ id, type })}
          />
        )}
      </Main>
    </>
  );
}
